<template>
  <div>
    <b-overlay :show="loading" :variant="!isDarkMode ? 'light' : 'dark'" rounded="sm" no-wrap>
      <template #overlay>
        <div class="d-flex justify-content-center align-items-center">
          <b-spinner :variant="!isDarkMode ? 'dark' : 'light'" label="Loading"></b-spinner>
        </div>
      </template>
    </b-overlay>
    <!-- <VideoCard /> -->
    <b-row>
      <b-col xs="12">
        <!-- box-shadow2 p-4 -->
        <div class="dashHead mb-5" style="border-radius: 20px">
          <b-row>
            <b-col lg="12" sm="12">
              <b-carousel
                v-model="videoSlide"
                id="carousel-1"
                :class="{ lightCarousel: !isDarkMode }"
                :interval="null"
                controls
                indicators
                no-touch
                img-width="1024"
                img-height="400"
                class="p-0 d-flex align-items-center justify-content-center"
                @sliding-start="onVideoSlideStart"
                @sliding-end="onVideoSlideEnd"
              >
                <b-carousel-slide v-for="(video, index) in approvedVideo" :key="video._id || index" img-blank>
                  <!-- Video Title -->
                  <h3 :class="{ 'text-dark': !isDarkMode, 'text-light': isDarkMode }"> Voice of Store</h3>
                  <!-- Video Player -->
                  <video
                    :src="video.actualUrl"
                    autoplay
                    playsinline
                    controls
                    loop
                    width="100%"
                    height="530"
                    style="border-radius: 10px"
                    muted
                  ></video>
                  <!-- object-fit: cover -->
                  <h4 :class="{ 'text-dark': !isDarkMode, 'text-light': isDarkMode }"> Category:- {{ video.type }} </h4>
                </b-carousel-slide>
              </b-carousel>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import _ from 'lodash';

export default {
  name: 'VideoSection',
  metaInfo() {
    return {
      title: 'Video Section',
      meta: [
        {
          name: 'description',
          content: `See Charts`
        }
      ]
    };
  },
  mounted() {
    if (this.$route.name === 'dashboardVideos') {
      this.title = 'Videos';
      this.isOnDashboardVideoPage = true;
    }
    if (_.isEmpty(this.$route.query)) {
      this.getApprovedVideo({
        router: this.$route
      });
    } else {
      this.getApprovedVideo(this.$route);
    }
  },
  computed: {
    ...mapState('darkMode', ['isDarkMode']),
    ...mapState('video', ['loading', 'baseUrl', 'videos', 'pagination']),
    videosToShow() {
      return this.isOnDashboardVideoPage ? this.filteredApprovedVideos : this.filteredApprovedVideos.slice(0, 1);
    }
  },
  watch: {
    videos(newValue) {
      if (newValue.length) {
        this.approvedVideo = newValue;
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.getApprovedVideo({ query: to.query });
    next();
  },
  methods: {
    ...mapActions('video', ['getApprovedVideo', 'deleteOne', 'patchOne']),
    videosPage() {
      this.$router.push('/dashboardVideos');
    },
    onVideoSlideStart() {
      this.sliding = true;
      // Optionally pause or reset videos here
    },
    onVideoSlideEnd() {
      // Wait for DOM update
      this.$nextTick(() => {
        const videos = this.$el.querySelectorAll('video');
        videos.forEach((video, i) => {
          if (i === this.videoSlide) {
            // Try to unmute and play active video
            video.muted = false;
            video.play().catch(err => {
            });
          } else {
            // Keep other videos muted
            video.muted = true;
          }
        });
      });
    }
  },
  data() {
    return {
      title: '',
      filteredApprovedVideos: [],
      isOnDashboardVideoPage: false,
      approvedVideo: [],
      videoSlide: 0,
      sliding: null
    };
  }
};
</script>
